import React, { useMemo, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import _lowerCase from 'lodash/lowerCase';

import { BADGE_COLOR, BADGE_ICON } from './helpers';

const StatusBadge = ({ status, className }) => {
  const displayedStatus = useMemo(() => {
    if (status === 'NA') {
      return 'N/A';
    }
    return _lowerCase(status);
  }, [status]);
  const normalizedStatus = useMemo(() => status?.toLowerCase(), [status]);

  return (
    <span
      className={`badge ${
        BADGE_COLOR[normalizedStatus] || 'neutral'
      } ${className}`}
      data-testid="status-badge"
    >
      <FontAwesomeIcon
        data-testid="icon"
        icon={BADGE_ICON[normalizedStatus] || ['far', 'hourglass']}
        className="my-auto mr-1 fill-current"
      />
      <span>{displayedStatus}</span>
    </span>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string,
  className: PropTypes.string,
};

StatusBadge.defaultProps = {
  status: 'settled',
  className: 'ml-6',
};

export default memo(StatusBadge);
